/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BriqueReferentielDto
 */
export interface BriqueReferentielDto {
    /**
     * 
     * @type {string}
     * @memberof BriqueReferentielDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof BriqueReferentielDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BriqueReferentielDto
     */
    estStandard: boolean;
    /**
     * 
     * @type {string}
     * @memberof BriqueReferentielDto
     */
    nomBase?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BriqueReferentielDto
     */
    portails: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BriqueReferentielDto
     */
    nbPermissions: number;
    /**
     * 
     * @type {number}
     * @memberof BriqueReferentielDto
     */
    nbPorteurs: number;
}

/**
 * Check if a given object implements the BriqueReferentielDto interface.
 */
export function instanceOfBriqueReferentielDto(value: object): value is BriqueReferentielDto {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('estStandard' in value) || value['estStandard'] === undefined) return false;
    if (!('portails' in value) || value['portails'] === undefined) return false;
    if (!('nbPermissions' in value) || value['nbPermissions'] === undefined) return false;
    if (!('nbPorteurs' in value) || value['nbPorteurs'] === undefined) return false;
    return true;
}

export function BriqueReferentielDtoFromJSON(json: any): BriqueReferentielDto {
    return BriqueReferentielDtoFromJSONTyped(json, false);
}

export function BriqueReferentielDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriqueReferentielDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'description': json['description'] == null ? undefined : json['description'],
        'estStandard': json['estStandard'],
        'nomBase': json['nomBase'] == null ? undefined : json['nomBase'],
        'portails': json['portails'],
        'nbPermissions': json['nbPermissions'],
        'nbPorteurs': json['nbPorteurs'],
    };
}

export function BriqueReferentielDtoToJSON(json: any): BriqueReferentielDto {
    return BriqueReferentielDtoToJSONTyped(json, false);
}

export function BriqueReferentielDtoToJSONTyped(value?: BriqueReferentielDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'description': value['description'],
        'estStandard': value['estStandard'],
        'nomBase': value['nomBase'],
        'portails': value['portails'],
        'nbPermissions': value['nbPermissions'],
        'nbPorteurs': value['nbPorteurs'],
    };
}

